import React from 'react';
import LocalizedStrings from 'react-localization';
import agent from '../../../../agent';
import { connect } from 'react-redux';
import EmployeeStatusWidget from './EmployeeStatusWidget'
import LoaderWidget from '../Loader/LoaderWidget'
import {checkForUnauthorisedResponse} from '../../../Utils/ErrorHandler'

const mapStateToProps = state => ({
  notification:state.signin.notification
});

class EmployeeStatusWidgetContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      locations: {},
      loaded:false
    };

    this.strings = new LocalizedStrings({
     en:{
       unavailable: 'Unavailable'
     },
     de: {
       unavailable: 'Nicht verfügbar'
     }
    });

    if(props.language) {
      this.strings.setLanguage(props.language);
    }
  }

  componentDidMount() {
    this.loadEmployees()
  }

  componentDidUpdate(prevProps, prevState) {
    this.checkIfEmployeeUpdateNeeded(prevProps);
  }

  checkIfEmployeeUpdateNeeded(prevProps) {
    const oldNotification = prevProps.notification ? prevProps.notification.notification : null;
    const newNotification = this.props.notification ? this.props.notification.notification : null;
    const oldType = prevProps.notification ? prevProps.notification.type : null;
    const newType = this.props.notification ? this.props.notification.type : null;

    if((!oldNotification && newNotification) ||
       (oldNotification && oldNotification.name !== newNotification.name) ||
       (oldNotification && oldType !== newType))  {
      this.loadEmployees();
    }
  }

  loadEmployees() {

    agent.Entity.getEmployees(this.props.timeOffSearchId).then(
      res => {
        if(res.result) {

          var locations = {}

          for(var i = 0; i < res.data.length; i++) {
            if(res.data[i].status && res.data[i].status) {
              var location = res.data[i].status.location;
              if(res.data[i].status.isWorkCalendarEvent) {
                location = this.strings.unavailable;
              }
              const employee = res.data[i];
              this.addEmployeeToLocation(locations, employee, location)
            }
          }

          this.setState({
            ...this.state,
            locations:locations,
            loaded:true
          })
        } else {
          this.setState({
            ...this.state,
            'loaded':true
          })
        }
      },
      error => {
        if(!checkForUnauthorisedResponse(error,agent)) {
          this.setState({
            ...this.state,
            'loaded':true
          })
        }
      }
    )

  }

  addEmployeeToLocation(locations, employee, location) {
    if(locations[location]) {
      locations[location].employees.push(employee);
    } else {
      locations[location] = {
        employees:[employee]
      }
    }
  }

  render() {
    if(this.state.loaded) {
      return (<EmployeeStatusWidget {...this.props} onWidgetRefresh={this.loadEmployees.bind(this)} refreshInterval={1800} locations={this.state.locations}/>)
    } else {
      return (
        <LoaderWidget {...this.props}/>
      )
    }
  }
}

export default connect(mapStateToProps)(EmployeeStatusWidgetContainer);



// WEBPACK FOOTER //
// ./src/components/Dashboard/components/EmployeeStatusWidget/EmployeeStatusWidgetContainer.js